import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { 
  Avatar,
  Box, 
  Button, 
  CircularProgress, 
  Container, 
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';

import TopBar from '../../../components/topBar/TopBar';
import NA from '../../../components/utils/NA';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { 
  GetMyProfile 
} from '../../../redux/actions/dashboard/profileActions';

import PasswordResetModal from './PasswordResetModal';

import global from "../../../global.scss";
import "./styles.scss";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector(state => state.dashboard);
  const [loading, setLoading] = useState(true);
  const [passwordResetModalOpen, setPasswordResetModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [update, setUpdate] = useState(null);

  const [profile, setProfile] = useState({});

  useEffect(() => {
    handleGetMyProfile();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      formatProfileObj(state.myProfile || {});
    } catch (err) {}
  }, [state]);

  const formatProfileObj = (obj) => {
    setProfile(obj);
  }; 

  async function handleGetMyProfile(customLoading) {
    dispatch(GetMyProfile(customLoading ? customLoading : setLoading));
  };

  return (
    <Box>
      
      <PasswordResetModal
        open={passwordResetModalOpen}
        setOpen={setPasswordResetModalOpen}
        title={modalTitle}
        update={update}
        handleGet={() => {}}
        />

      <Container
        maxWidth="md">
        <Box
          className="flexCenter_Row"
          gap={"15px"}>
          <IconButton
            onClick={() => {
              navigate(-1);
            }}>
            <ArrowBackIcon 
              sx={{ width: "40px", height: "40px" }}/>
          </IconButton>
          <Box
            sx={{ paddingTop: "20px" }}>
            <TopBar
              title={"Profile"}
              />
          </Box>
        </Box>

        {
          loading
          ?
          <Box
            height={"400px"}
            className="flexCenterCenterRow">
            <CircularProgress 
              size={"50px"}/>
          </Box>
          :
            <Box
              className="flex__Column"
              sx={{ width: "450px", margin: "auto" }}>
              <Box
                className="flexCenter_Row"
                gap="15px"
                width={"100%"}
                mb={"15px"}>
                <Avatar
                  sx={{ backgroundColor: global["secondary"], 
                    width: "55px", 
                    height: "55px"
                  }}>
                  <Typography
                    variant='h6'
                    color={"white"}>
                    {"first_name" in profile && profile?.first_name[0]?.toUpperCase()}
                    {"last_name" in profile && profile?.last_name[0]?.toUpperCase()}
                  </Typography>
                </Avatar>
                <Typography
                  variant='h5'>
                  {profile?.first_name || <NA />}&nbsp;{profile?.last_name || <NA />}
                </Typography>
              </Box>
              <Box
                className="flexCenter_Row"
                gap="15px"
                pl={"70px"}>
                <Typography
                  variant='body1'
                  color={"grey"}
                  width={"50px"}>
                  Email
                </Typography>
                <Typography
                  variant='subtitle2'>
                  <Tooltip
                    title="Primary email">
                    {profile?.primary_email || <NA />}
                  </Tooltip>
                  {/* &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                  <Tooltip
                    title="Secondary email">
                    {profile?.secondary_email || <NA />}
                  </Tooltip> */}
                </Typography>
              </Box>
              <Box
                className="flexCenter_Row"
                gap="15px"
                pl={"70px"}
                mb={"40px"}>
                <Typography
                  variant='body1'
                  color={"grey"}
                  width={"50px"}>
                  Mobile
                </Typography>
                <Typography
                  variant='subtitle2'>
                  <Tooltip
                    title="Primary mobile">
                    {
                      profile?.primary_mobile
                      ? "+" + profile?.primary_mobile_country_code + " " + profile?.primary_mobile  
                      : <NA />
                    }
                  </Tooltip>
                  {/* &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                  <Tooltip
                    title="Secondary mobile">
                    {
                      profile?.secondary_mobile
                      ? "+" + profile?.secondary_mobile_country_code + " " + profile?.secondary_mobile  
                      : <NA />
                    }
                  </Tooltip> */}
                </Typography>
              </Box>

              <Box
                mb={"40px"}
                className="flexCenterSBRow">
                <Button
                  variant='outlined'
                  onClick={() => {
                    setUpdate({
                      defaultMode: 1
                    });
                    setModalTitle("Change password")
                    setPasswordResetModalOpen(!passwordResetModalOpen);
                  }}>
                  Password reset
                </Button>
              </Box>

            </Box>
        }
      </Container>
    </Box>
  )
}

export default ProfilePage